/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Inspection } from '../../models/inspection';

export interface ApiV0InspectionGetByCompanyGet$Plain$Params {
  CompanyId?: string;
}

export function apiV0InspectionGetByCompanyGet$Plain(http: HttpClient, rootUrl: string, params?: ApiV0InspectionGetByCompanyGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Inspection>>> {
  const rb = new RequestBuilder(rootUrl, apiV0InspectionGetByCompanyGet$Plain.PATH, 'get');
  if (params) {
    rb.query('CompanyId', params.CompanyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Inspection>>;
    })
  );
}

apiV0InspectionGetByCompanyGet$Plain.PATH = '/api/v0/inspection/getByCompany';
